import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FuseConfigService } from "../@fuse/services/config";
import {environment} from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _fuseConfigService: FuseConfigService,
        private _router: Router,
    ) {
        this.setEnvironmentUiType();
        // environment.user_ui_type = 4;

        if (localStorage.getItem('fuse-scheme') !== 'light') {
            localStorage.setItem('fuse-scheme', 'light');
            this._fuseConfigService.config = { scheme: 'light' };
        }

        window.addEventListener('storage', function (event) {
            if (event.key == 'reload' && event.newValue == 'true') {
                let redirectURL = '/signed-in-redirect';
                let params = new URLSearchParams(window.location.search);
                redirectURL = params.get('redirectURL');
                if (localStorage.getItem('ACCOUNT_DETAILS') !== null) {
                    const currentUser = JSON.parse(localStorage.getItem('ACCOUNT_DETAILS')).ds_email;
                    if (currentUser === localStorage.getItem('last_user')) {
                        _router.navigateByUrl(redirectURL).then();
                    } else {
                        window.location.href = '/dashboards/project';
                    }
                } else {
                    window.location.reload();
                }
                localStorage.setItem('reload', 'false');
            }
        });
    }

    private setEnvironmentUiType(): void {
        const accountDetailsStr = localStorage.getItem('ACCOUNT_DETAILS');

        if (accountDetailsStr) {
            try {
                const accountDetails = JSON.parse(accountDetailsStr);
                if (accountDetails && accountDetails.en_logintype !== undefined) {
                    environment.user_ui_type = accountDetails.en_logintype;
                    return;
                }
            } catch (e) {
            }
        }

        const hostname = window.location.hostname;
        const subdomain = hostname.split('.')[0];

        switch (subdomain) {
            case 'admin':
                environment.user_ui_type = 3;
                break;
            case 'ambassador':
                environment.user_ui_type = 4;
                break;
            case 'manage':
            default:
                environment.user_ui_type = 2;
                break;
        }
    }
}
